export const PRE_SIGNUP_BASE_PATH = '/pre-signup';

// Screen name constants
export const WELCOME = 'welcome';
export const HOW_TO_PAY = 'how-to-pay';
export const GETTING_STARTED = 'getting-started';
export const NAME = 'name';
export const GREETINGS = 'greetings';
export const ZIP_CODE = 'zip-code';
export const ZIP_CODE_WELCOME = 'zip-code-welcome';

export const SYMPTOMS = 'symptoms';
export const SYMPTOMS_DURATION = 'symptoms-duration';
export const SYMPTOM_CHECK = 'symptom-check';
export const TREATMENT_GOALS = 'treatment-goals';
export const HOW_TO_SUPPORT = 'how-to-support';
export const TREATMENT_CHECK = 'treatment-check';
export const SELF_PAY_VALIDATION = 'self-pay-validation';

const MEDS_FLOW: Record<string, { next: string | null; showSteps?: boolean }> = {
  [WELCOME]: { next: SYMPTOMS, showSteps: true },
  [SYMPTOMS]: { next: SYMPTOMS_DURATION, showSteps: true },
  [SYMPTOMS_DURATION]: { next: SYMPTOM_CHECK, showSteps: true },
  [SYMPTOM_CHECK]: { next: ZIP_CODE },
  [ZIP_CODE]: { next: ZIP_CODE_WELCOME, showSteps: true },
  [ZIP_CODE_WELCOME]: { next: TREATMENT_GOALS },
  [TREATMENT_GOALS]: { next: HOW_TO_SUPPORT, showSteps: true },
  [HOW_TO_SUPPORT]: { next: TREATMENT_CHECK, showSteps: true },
  [TREATMENT_CHECK]: { next: HOW_TO_PAY },
  [HOW_TO_PAY]: { next: GETTING_STARTED, showSteps: true },
  [SELF_PAY_VALIDATION]: { next: GETTING_STARTED },
  [GETTING_STARTED]: { next: null }
};

export const MEDS_FUNNEL_DOT_STEPS = Object.entries(MEDS_FLOW)
  .filter(([, { showSteps }]) => showSteps)
  .map(([screen]) => screen);

export interface FlowContext {
  isCouplesTherapy: boolean;
  isSelfPay: boolean;
  isMedsCoreFunnel: boolean;
}

export const getNextQuestion = (current: string, context: FlowContext): string | null => {
  const { isCouplesTherapy, isSelfPay, isMedsCoreFunnel } = context;

  if (!isMedsCoreFunnel) {
    const legacyFlow: Record<string, string | null> = {
      [WELCOME]: isCouplesTherapy ? GETTING_STARTED : HOW_TO_PAY,
      [HOW_TO_PAY]: GETTING_STARTED,
      [GETTING_STARTED]: NAME,
      [NAME]: GREETINGS,
      [GREETINGS]: ZIP_CODE,
      [ZIP_CODE]: ZIP_CODE_WELCOME,
      [ZIP_CODE_WELCOME]: null
    };
    return legacyFlow[current] ?? null;
  }

  if (current === WELCOME) return isCouplesTherapy ? ZIP_CODE : SYMPTOMS;
  if (current === ZIP_CODE_WELCOME) return isCouplesTherapy ? HOW_TO_PAY : TREATMENT_GOALS;
  if (current === HOW_TO_PAY) return isSelfPay ? SELF_PAY_VALIDATION : GETTING_STARTED;

  return MEDS_FLOW[current]?.next ?? null;
};
